function WebsiteSVG({ withClass }) {
  return (
    <svg
      className={withClass}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none !important"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9143 10C18.9143 15.1207 14.8362 19.25 9.83215 19.25C4.82814 19.25 0.75 15.1207 0.75 10C0.75 4.87935 4.82814 0.75 9.83215 0.75C14.8362 0.75 18.9143 4.87935 18.9143 10Z"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 19.3244C12.7614 19.3244 15 15.2262 15 10.1707C15 5.11532 12.7614 1.01709 10 1.01709C7.23858 1.01709 5 5.11532 5 10.1707C5 15.2262 7.23858 19.3244 10 19.3244Z"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1.01709L10 19.3244"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.5083H17"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 10H18.5"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15.256H2.5"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { WebsiteSVG };
